export default __webpack_public_path__ + "static/media/playlistimg.87a16dfe.png";